import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=6b8d63f0&"
import script from "./OurServices.vue?vue&type=script&lang=js&"
export * from "./OurServices.vue?vue&type=script&lang=js&"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=6b8d63f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports